var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.97905 4.24607C4.97905 4.38931 4.92228 4.53252 4.80898 4.64173L1.24177 8.07817C1.01486 8.29678 0.646947 8.29678 0.42012 8.07817C0.193293 7.85966 0.193293 7.5053 0.42012 7.28668L3.57658 4.24607L0.42023 1.20544C0.193404 0.98684 0.193404 0.632519 0.42023 0.414022C0.647057 0.195313 1.01497 0.195313 1.24188 0.414022L4.80909 3.85041C4.92241 3.95967 4.97905 4.10289 4.97905 4.24607Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleRight);
export default __webpack_public_path__ + "static/media/AngleRight.f8e9a86f7ff339b41e8013a8fa705cc9.svg";
export { ForwardRef as ReactComponent };